import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateReject = async ({
  communityId,
  budgetId,
  reason,
}: {
  communityId: string;
  budgetId: string;
  reason: string;
}) => {
  return await axiosAuth.post(
    `${BUDGET(communityId)}/${budgetId}/reject?reason=${encodeURIComponent(reason)}`
  );
};

const useRejectMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateReject,
    ...queryParams,
  });

export default useRejectMutation;